import z from 'zod'

export const GetCommentSchema = z.object({
  content: z.string(),
  created_at: z.coerce.date(),
  id: z.number(),
  id_modified: z.boolean().nullish(),
  load_id: z.coerce.number(),
  updated_at: z.coerce.date(),
})
